import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component ({
    selector: 'initialization-component',
    templateUrl: 'initialization.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InitializationComponent {
    
}